module.exports = __webpack_public_path__ + "img/total-number.4f17ce1d.svg";